import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../../../../AppModule/Context';

import ToolTipComponent from '../../toolTipComponent';

import expertHomeService from '../../../../../services/expertHomeService';

import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './mentorPillComponent.css';

const MentorPillComponent = ({
  hideToolTip = false,
  isChatUI = false,
  isDisabled = false,
  isMentorSide = true,
  isSmallPill = false,
  isPrimary = false,
  customToolTipTxt = null,
  showMentorEmail = true,
  showMentorName = true,
  icon = null,
  extendedMentorDto = {},
  toolTipPosition = 'right',
  widgetName = '',
}) => {
  const context = useContext(AppContext);

  const [pillText, setPillText] = useState('');
  const [showToolTip, setShowToolTip] = useState(false);
  const [toolTipTxt, setToolTipTxt] = useState('');

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  useEffect(() => {
    if (Object.keys(extendedMentorDto || {}).length) {
      const pillText = expertHomeService.getMentorPillName(extendedMentorDto);
      const email = context.isAccountManager
        ? extendedMentorDto.email
        : context.currentUser.email;
      const toolTipTxt = isMentorSide
        ? customToolTipTxt ??
          (extendedMentorDto.mentorDto.mentorOwnerType ===
          VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET
            ? `Shared team conversation
            Display name: ${extendedMentorDto.mentorDto.displayName}
            Handle: ${extendedMentorDto.mentorDto.profileName}`
            : `Widget: ${widgetName} ${
                showMentorName
                  ? `\n Display name: ${extendedMentorDto.mentorDto.displayName}`
                  : ''
              } ${showMentorEmail ? `\n Email: ${email}` : ''} \n Handle: ${
                extendedMentorDto.mentorDto.profileName
              }`)
        : null;
      setToolTipTxt(toolTipTxt);
      setPillText(pillText);
    }
  }, [extendedMentorDto, widgetName]);

  return (
    <div
      className={`et-v2-mentor-pill-container ${
        isSmallPill ? 'et-v2-mentor-small-pill-container' : ''
      } ${isDisabled ? 'et-v2-mentor-pill-container-disabled' : ''} ${isChatUI ? 'et-v2-mentor-pill-container-chat' : ''}`}
      style={{
        backgroundColor: extendedMentorDto?.mentorPillColor,
      }}
      onMouseEnter={handleToolTip}
      onMouseLeave={handleToolTip}>
      {icon ? icon : pillText}
      {showToolTip && !hideToolTip && (
        <ToolTipComponent
          toolTipPosition={toolTipPosition}
          toolTipTxt={toolTipTxt}
        />
      )}
      {isPrimary && <div className="et-v2-mentor-pill-primary-dot" />}
    </div>
  );
};

export default MentorPillComponent;
